import React from 'react';
import { useUnWatchGmailAccounts, useWatchGmailAccounts } from 'mutation/gmail';
import { useGetGmailAccountWatchStatus } from 'query/gmail';
import { Button } from 'components/ui';

const WatchGmailAccountsButton = () => {
  const {
    data: watchStatus,
    isLoading: isFetchingWatchStatus,
  } = useGetGmailAccountWatchStatus();
  const {
    mutate: unWatchAccounts,
    isLoading: isUnWatching,
  } = useUnWatchGmailAccounts();
  const {
    mutate: watchAccounts,
    isLoading: isWatching,
  } = useWatchGmailAccounts();

  const isWatched = !!watchStatus?.active;

  return (
    <Button
      loading={isFetchingWatchStatus || isUnWatching || isWatching}
      style={
        isWatched
          ? {
              backgroundColor: 'dodgerblue',
              color: 'white',
              marginLeft: 5,
            }
          : { marginLeft: 5 }
      }
      onClick={() => (isWatched ? unWatchAccounts() : watchAccounts())}
    >
      <span className="material-icons">
        {isWatched ? 'visibility' : 'visibility_off'}
      </span>
      {isWatched ? 'Watching' : 'Click to watch'}
    </Button>
  );
};

export default WatchGmailAccountsButton;
